import { Button, Stack, Typography } from "@mui/material";
import { useState } from "react";
import ExpandIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import "./styles.scss";

export const Accordion = ({
  title = "Frequently Asked Questions",
  items,
}: {
  title?: string;
  items: Array<{ title: string; description: string }>;
}) => {
  const [activeItem, setActiveItem] = useState<string | null>(null);

  return (
    <div className="accordion">
      <Typography
        variant="h4"
        component="h4"
        mb="20px"
        className="accordion-title font-body text-center font-size-5"
      >
        {title}
      </Typography>
      {items.map((item, index) => (
        <div key={index} className="accordion-item">
          <Button
            className="accordion-item-button"
            color={"black" as any}
            variant="text"
            disableRipple
            onClick={() =>
              setActiveItem(activeItem === item.title ? null : item.title)
            }
            sx={{
              '&:active': {
                backgroundColor: 'transparent',
                boxShadow: 'none',
              },
            }}
          >
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems=""
              width="100%"
            >
              <Typography
                variant="h6"
                className="accordion-item-title font-body margin-0 text-left font-size-4"
              >
                {item.title}
              </Typography>
              {activeItem === item.title ? (
                <ExpandLessIcon fontSize="small" />
              ) : (
                <ExpandIcon fontSize="small" />
              )}
            </Stack>
          </Button>
          {activeItem === item.title && (
            <div className="accordion-item-content contain-text-small">
              <Typography
                variant="body1"
                className="accordion-item-description margin-0 font-size-4 text-left"
              >
                {item.description}
              </Typography>
            </div>
          )}
        </div>
      ))}
    </div>
  );
};
